import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchDetails, updateLike, updateSaved } from './detailsAPI';

const initialState = {
    details: {},
    loading: false,
    errorMessage: '',
    isError: '',
};

export const getDetails = createAsyncThunk(
    'details/fetchDetails',
    async (id) => {
        const data = await fetchDetails(id);
        return data;
    }
);

export const addLike = createAsyncThunk(
    'details/addLike',
    async (info) => {
        const data = await updateLike(info)
        return data
    }
)
export const saved = createAsyncThunk(
    'details/saved',
    async (info) => {
        const data = await updateSaved(info)
        return data
    }
)

export const detailsSlice = createSlice({
    name: 'details',
    initialState,

    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder) => {
        builder
            .addCase(getDetails.pending, (state) => {
                state.loading = true;
                state.errorMessage = '';
                state.isError = false;
                state.details = {};
            })
            .addCase(getDetails.fulfilled, (state, action) => {
                state.loading = false;
                state.errorMessage = '';
                state.isError = false;
                state.details = action.payload;
            })
            .addCase(getDetails.rejected, (state, action) => {
                state.loading = false;
                state.errorMessage = action.error;
                state.isError = true;
                state.details = {};
            })
            .addCase(addLike.fulfilled, (state, action) => {
                state.details.likes = action.payload.likes;
            })
            .addCase(saved.fulfilled, (state, action) => {
                state.details.isSaved = action.payload.isSaved;
            })
    },
});


// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)` 
export default detailsSlice.reducer;
